import { getStrings } from '../../../Common/Localization/commonStrings';

const localizedStrings = {
    timeOutErrorStrings : {
    strings :  {    
      en : {    
        errorMessage1: 'It looks like this didn’t finish loading, but refreshing the page should fix it. If that doesn’t work try asking our ',
        hyperlinkText : 'Ask SCE',
        errorMessage2: ' chat bot. ',
    },    
      es: {
      } 
    },
  },
timeOutErrorStringsClaims : {
    strings :  {    
      en : {    
        errorMessage1: "",
        hyperlinkText : "",
        errorMessage2: "",
        claimserrorMessage: "It looks like your documents didn't finish loading. Please refresh the page and try again. If the issue persists, you can email us your request at <a style='text-decoration:underline;' href='mailto:Claims@sce.com'> Claims@sce.com </a> or fax it to <a style='text-decoration:underline;' href='tel:1-626-569-2573'>1-626-569-2573</a>",
    },    
      es: {
      } 
    },
  },
};

export const getLocalizedStrings = (componentName) => {
  app.logger.getLogger().info("Comp Name" + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
  //return new LocalizedStrings(strings);
};
